import { Description } from "@/components/ui/field";
import { Heading } from "@/components/ui/heading";
import type { WorkflowStep as TWorkflowStep } from "../../types";
import { useWorkspace } from "../WorkspaceProvider";

export function WorkflowHeader({
  step,
  actions,
  title,
}: {
  step: TWorkflowStep;
  actions?: React.ReactNode;
  title?: string;
}) {
  const { testSpec } = useWorkspace();
  return (
    <div className="flex flex-col gap-1.5 px-6 py-4 border-b">
      <div className="flex gap-2 justify-between">
        <Heading level={2}>{title || step.title}</Heading>
        {actions}
      </div>
      <Description>{testSpec.name}</Description>
    </div>
  );
}
